// Copyright (c) 2020 Deere & Company

import Accordion, {getDefaultState as getAccordionDefaultState} from '../../../shared/components/smart-accordion/state/accordion';
import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../../shared/state/busy-counter';
import DealerHierarchyFacet, {getDefaultState as getDealerHierarchyFacetDefaultState} from '../../shared/state/dealer-hierarchy-facet';
import FilteredTerritories, {getDefaultState as getFilteredTerritoriesDefaultState} from '../../shared/state/filtered-territories';
import SearchByDropDown, {getDefaultState as getSearchByDropDownDefaultState} from './search-by-dropdown';
import SelectedSpaLevels, {getDefaultState as getSelectedSpaLevelsDefaultState} from './selected-spa-levels';
import SpaClaims, {getDefaultState as getSpaClaimsDefaultState} from './spa-claims';
import StatusChange, {getDefaultState as getStatusChangeDefaultState} from '@deere/cps-it.warranty-model-factory/lib/status-change';
import TcsmApproveDenyModal, {getDefaultState as getTcsmApproveDenyModalDefaultState} from './tcsm-approve-deny-modal';
import TcsmSettings, {getDefaultState as getTcsmSettingsDefaultState} from '@deere/cps-it.warranty-model-factory/lib/tcsm-settings';
import SearchFilters from '../../../shared/state/search-filters';
import {getDefaultState as getSearchFiltersDefaultState} from '../../../shared/services/get-default-filter-state';
import t from 'tcomb';

const State = t.struct({
    busyCounter: BusyCounter,
    closingAccountLength: t.Number,
    closingAccountSearchFilters: SearchFilters,
    facetFilterText: t.String,
    filteredTerritories: FilteredTerritories,
    initialLoad: t.Bool,
    laborRateChangesLength: t.Number,
    laborRateChangesSearchFilters: SearchFilters,
    machineStatusItemToUpdate: StatusChange,
    machineStatusModal: TcsmApproveDenyModal,
    machineStatusSearchFilters: SearchFilters,
    pipCodeRequestModal: TcsmApproveDenyModal,
    pipCodeRequestSearchFilters: SearchFilters,
    reportsAccordion: Accordion,
    searchByDropDown: SearchByDropDown,
    searchQueryString: t.String,
    selectedSpaLevels: SelectedSpaLevels,
    specialAllowanceClaims: SpaClaims,
    specialAllowanceClaimsSearchFilters: SearchFilters,
    tcsmSettings: TcsmSettings,
    wipFacets: DealerHierarchyFacet
}, {
    name: 'State',
    strict: true
});

export const getDefaultState = () =>
    new State({
        busyCounter: getBusyCounterDefaultState(),
        closingAccountLength: 0,
        closingAccountSearchFilters: getSearchFiltersDefaultState('', '', ['businessEndDate'], 'ASC'),
        facetFilterText: '',
        filteredTerritories: getFilteredTerritoriesDefaultState(),
        initialLoad: true,
        laborRateChangesLength: 0,
        laborRateChangesSearchFilters: getSearchFiltersDefaultState('', '', ['requestDate'], 'ASC'),
        machineStatusItemToUpdate: getStatusChangeDefaultState(),
        machineStatusModal: getTcsmApproveDenyModalDefaultState(),
        machineStatusSearchFilters: getSearchFiltersDefaultState('', '', ['createdDate'], 'ASC'),
        pipCodeRequestModal: getTcsmApproveDenyModalDefaultState(),
        pipCodeRequestSearchFilters: getSearchFiltersDefaultState('', '', ['createDate'], 'ASC'),
        reportsAccordion: getAccordionDefaultState('tcsm-reports-accordion'),
        searchByDropDown: getSearchByDropDownDefaultState(),
        searchQueryString: '',
        selectedSpaLevels: getSelectedSpaLevelsDefaultState(),
        specialAllowanceClaims: getSpaClaimsDefaultState(),
        specialAllowanceClaimsSearchFilters: getSearchFiltersDefaultState('', '', ['submittedDate'], 'ASC'),
        tcsmSettings: getTcsmSettingsDefaultState(),
        wipFacets: getDealerHierarchyFacetDefaultState()
    });

export default State;



// WEBPACK FOOTER //
// ./src/tabm/wip/state/index.js